// Step 23 — attention chips for a contract row.
//
// One chip per deterministic observation from `contractAttentionFlags`.
// Explicitly NOT a score — each chip is a distinct, explainable signal
// derived from status + counts the backend already returned.

import { contractAttentionFlags } from "./helpers";

export default function AIContractAttentionChips({ row }) {
  const flags = contractAttentionFlags(row);
  if (flags.length === 0) return null;
  return (
    <div className="qai-contract-attention-chips">
      {flags.map((f) => (
        <span
          key={f.kind}
          className="qai-contract-attention-chip"
          data-severity={f.severity}
          title={f.title}
        >
          {f.label}
        </span>
      ))}
    </div>
  );
}
